export enum RespondentSource {
  LUCID = 'lucid',
  CINT = 'cint'
}

export enum DemographicKey {
  AGE='AGE',
  STANDARD_EDUCATION='STANDARD_EDUCATION',
  STANDARD_EMPLOYMENT='STANDARD_EMPLOYMENT',
  GENDER='GENDER',
  STANDARD_HHI_US='STANDARD_HHI_US',
  STANDARD_INDUSTRY_PERSONAL='STANDARD_INDUSTRY_PERSONAL',
  STATE='STATE',
  MS_is_mobile='MS_is_mobile',
  STANDARD_JOB_TITLE='STANDARD_JOB_TITLE',
  Parental_Status_Standard='Parental_Status_Standard',
  STANDARD_RELATIONSHIP='STANDARD_RELATIONSHIP',
  STANDARD_HOUSEHOLD_TYPE='STANDARD_HOUSEHOLD_TYPE',
  STANDARD_COMPANY_DEPARTMENT='STANDARD_COMPANY_DEPARTMENT',
  STANDARD_B2B_DECISION_MAKER='STANDARD_B2B_DECISION_MAKER',
  STANDARD_NO_OF_EMPLOYEES='STANDARD_NO_OF_EMPLOYEES',
  Big_Ticket_Purchases='Big_Ticket_Purchases'
}

export enum QuestionType {
  SINGLE_SELECT='single-select',
  MULTI_SELECT='multi-select',
  RANK='rank',
  TEXTAREA='textarea',
  NUMERIC='numeric',
  VARIANT='variant',
  RATE='rate',
  RATE_ONLY='rate-only',
  MATRIX_LIKERT='matrix-likert',
  DESCRIPTION='description',
  TASK='task',
  NUMBER='number',
  QUAL_VERBAL='qual-verbal',
  QUAL_SINGLE_SELECT='qual-single-select',
  QUAL_TASK='qual-task',
  QUAL_RATE='qual-rate',
  QUAL_MULTI_SELECT='qual-multi-select',
  QUAL_TEXTAREA='qual-textarea',
  MOBILE_UPLOAD='mobile-upload',
  VERBAL='verbal'
}

export enum SurveyType {
  QUANT='quant',
  QUAL='qual',
  SCREENER='screener'
}

export enum TestType {
  Template='Template',
  UserDiscovery='User Discovery',
  CompetitiveOverview='Competitive Overview',
  ProductConceptTesting='Product Concept Testing',
  Comparison='Comparison',
  ProductDiscovery='Product Discovery',
  FeaturePrioritization='Feature Prioritization',
  UXRefinement='UX Refinement',
  UsabilityTesting='Usability Testing',
  None='None'
}

export enum QuestionOptionQualificationImpact {
  QUALIFIES='qualifies',
  DISQUALIFIES='disqualifies'
}
